var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8987 49.7877L40.6987 5.4877V5.3877C38.8987 2.2877 35.6987 0.387695 32.0987 0.387695C28.4987 0.387695 25.2987 2.2877 23.3987 5.4877L0.898733 50.2877C-0.501267 53.3877 -0.201266 56.9877 1.59873 59.7877C3.39873 62.6877 6.59873 64.3877 9.99873 64.3877H53.9987C57.4987 64.3877 60.6987 62.5877 62.4987 59.5877C64.3987 56.5877 64.4987 52.8877 62.8987 49.7877ZM59.0987 57.4877C57.9987 59.2877 56.0987 60.3877 53.9987 60.3877H9.99873C7.89873 60.3877 6.09873 59.3877 4.99873 57.6877C3.89873 55.9877 3.69873 53.8877 4.49873 52.0877L26.7987 7.3877C27.8987 5.4877 29.7987 4.3877 31.9987 4.3877C34.0987 4.3877 36.0987 5.4877 37.1987 7.3877L59.3987 51.6877C60.2987 53.4877 60.1987 55.6877 59.0987 57.4877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20.2876H30V44.3876H34V20.2876Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48.3877H30V56.3877H34V48.3877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrAlert);
export default __webpack_public_path__ + "static/media/ubr-alert.c6e97ecc333fd376d4ba7566aac1a438.svg";
export { ForwardRef as ReactComponent };